module.exports = __webpack_public_path__ + "img/08.01a03c4e.png";